function createExperiencePlugin() {
  const pr = new Intl.PluralRules("ru-RU");
  const words = {
    one: "год",
    few: "года",
    many: "лет",
  };
  Alpine.magic("experience", (el, { Alpine }) => {
    return (expression, options = {}) => {
      const isShort = options?.isShort;

      if (!expression) return;
      const start = new Date(expression);
      const now = new Date();

      if (isNaN(start.getTime())) return;

      let diff = now.getFullYear() - start.getFullYear();
      const m = now.getMonth() - start.getMonth();

      if (m < 0 || (m === 0 && now.getDate() < start.getDate())) {
        diff--;
      }

      let result = "";
      if (diff <= 0) {
        result = isShort ? "< 1 г." : "меньше года";
      } else {
        const res = words[pr.select(diff)];
        const word = isShort ? `${res[0]}.` : res;
        result = `${diff} ${word}`;
      }

      return result;
    };
  });
}

export { createExperiencePlugin };
